import PropTypes from 'prop-types'
import { forwardRef, memo, useMemo } from 'react'
import useFallbackRef from 'lib/react/hooks/useFallbackRef'
import classNames from 'lib/util/classNames'
import lineItemStyles from '../LineItem.module.scss'
import styles from './Value.module.scss'

/**
 * The `Value`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
const Value = forwardRef((props, forwardedRef) => {
  const { children, className } = props
  const ref = useFallbackRef(forwardedRef)
  const classNameOutput = useMemo(
    () => classNames([className, lineItemStyles.value, styles.value]),
    [className]
  )

  return (
    <div ref={ref} className={classNameOutput}>
      {children}
    </div>
  )
})

// Display name
Value.displayName = 'Value'

/** @type {object} */
Value.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
}

/** @type {object} */
Value.defaultProps = {
  children: null,
  className: ''
}

// Memoize
export default memo(Value)
